<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <div class="fl m-r-30">
        <el-button size="small" type="success" @click="$router.push({ name: 'userAdd' })"><i class="el-icon-plus"></i>&nbsp;&nbsp;添加游客</el-button>
      </div>
      <div class="fl w-400">
        <el-input placeholder="请输入账号/真实姓名/最近登录企业" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="id"
      label="ID"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="user_head"
      label="头像"
      min-width="100">
        <template scope="scope">
          <el-popover
            placement="right-end"
            width="400"
            trigger="click">
            <img :src="scope.row.user_head?scope.row.user_head:logo2" width="100%">
            <img :src="scope.row.user_head?scope.row.user_head:logo2" width="50" height="50" slot="reference">
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
      prop="username"
      label="账号"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="user_name"
      label="真实姓名"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="create_time"
      label="注册时间"
      width="180"
      :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column
      label="性别">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.sex == 1" >男</span>
            <span v-else-if = "scope.row.sex == 2" style="color:red">女</span>
            <span v-else>未设置</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
      label="状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1" class="success_status">正常</span>
            <span v-else-if = "scope.row.status ==0" class="goon_status">{{ scope.row.status | status }}</span>
            <span v-else-if = "scope.row.status ==-1" class="error_status">{{ scope.row.status | status }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      width="180">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="$router.push({ name: 'user_add_companyList', params: { id: scope.row.id,username: scope.row.username }})">添加企业</el-button>
              <!-- <el-button size="small" type="primary" @click="$router.push({ name: 'user_billList', params: { id: scope.row.id }})">票据</el-button> -->
              <el-button size="small" type="primary" @click="$router.push({ name: 'userEdit', params: { id: scope.row.id }})">编辑</el-button>
              <!-- <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button> -->
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'user'"></btnGroup>
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除该用户?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/user/', item.id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '删除成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/user', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('user-save')
      },
      editShow() {
        return _g.getHasRule('user-update')
      },
      deleteShow() {
        return _g.getHasRule('user-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?7590ab05